import { apiClient } from './client';

export interface ResourceLink {
  id: string;
  title: string;
  description: string | null;
  url: string;
  feature: string;
  category: string | null;
  source: string;
  tags: string[];
  isPinned: boolean;
  sortOrder: number;
  verifiedAt: string | null;
  updatedAt: string;
}

export interface ResourceSection {
  feature: string;
  label: string;
  links: ResourceLink[];
}

export interface ResourceMeta {
  features: Array<{ id: string; label: string }>;
  sources: string[];
  /** Live links filed under a feature that no longer exists — invisible to everyone. */
  orphaned: ResourceLink[];
}

export interface ResourceLinkInput {
  title: string;
  description?: string | null;
  url: string;
  feature: string;
  category?: string | null;
  source?: string;
  tags?: string[];
  isPinned?: boolean;
  sortOrder?: number;
}

export async function getResources(): Promise<{ sections: ResourceSection[] }> {
  return apiClient.get('/resources');
}

export async function getResourceMeta(): Promise<ResourceMeta> {
  return apiClient.get('/resources/meta');
}

export async function createResourceLink(input: ResourceLinkInput): Promise<{ link: ResourceLink }> {
  return apiClient.post('/resources', input);
}

export async function updateResourceLink(
  id: string,
  input: Partial<ResourceLinkInput> & { verified?: boolean },
): Promise<{ link: ResourceLink }> {
  return apiClient.patch(`/resources/${id}`, input);
}

export async function deleteResourceLink(id: string): Promise<{ success: boolean }> {
  return apiClient.delete(`/resources/${id}`);
}
